import { Icon } from 'antd'
import { GlobalContext } from 'Global'
import { get } from 'lodash'
import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import Dropdown from 'views/Dropdown'

function compareString(_a = '', _b = '') {
  const a = _a.toUpperCase().trim()
  const b = _b.toUpperCase().trim()

  return a.includes(b)
}

function SiderMenu(props) {
  const { collapsed, setCollapsed, scopes } = React.useContext(GlobalContext)

  const [list, setList] = useState(fullList)
  const path = get(props, 'location.pathname', '')

  const [current, setCurrent] = useState(path)
  const [openKeys, setOpenKeys] = useState([])

  useEffect(() => {
    const currentTab = list.map((i) => i.to).filter((i) => (i || '').includes(current.split('/')[1]))
    setOpenKeys(collapsed ? [] : currentTab)
  }, [collapsed])

  function handleClick(e) {
    if (current === '/' && e.key === '/') window.location.reload()
    setCurrent(e.key)
  }

  function onSearch(e) {
    const value = e.target.value || ''
    let newList = fullList.filter((i) => {
      if (i.sub && i.sub.length > 0) {
        return i.sub.filter((j) => compareString(j.text, value)).length > 0
      } else {
        return compareString(i.text, value)
      }
    })

    newList = newList.map((i) => {
      if (i.sub && i.sub.length > 0) {
        const newItem = i.sub.filter((j) => compareString(j.text, value))
        return {
          ...i,
          sub: newItem,
        }
      } else {
        return i
      }
    })

    setOpenKeys(value === '' ? ['/'] : newList.map((i) => i.to))
    setList(newList)
  }

  const Items = (collapsed) => (
    <div>
      {list
        .filter((i) => scopes.includes(i.id))
        .map((i, _) => (
          <Dropdown {...{ key: i.text, title: i.text, ...i }} />
        ))}
    </div>
  )

  return (
    <div
      onMouseEnter={() => setCollapsed(false)}
      onMouseLeave={() => setCollapsed(true)}
      className={`flex-shrink-0 ${collapsed ? 'w-16 hover:w-64 overflow-hidden' : 'w-64'} p-6 bg-gray-100`}>
      {!collapsed && (
        <div className="relative mb-5">
          <span className="absolute inset-y-0 left-0 flex items-center pl-1">
            <Icon
              type="search"
              style={{
                color: '#a0aec0',
                fontSize: '20px',
                marginLeft: '2px',
              }}
            />
          </span>
          <input
            className="block pl-8 w-full px-4 py-2 bg-gray-900 rounded-lg text-sm placeholder-gray-600 text-white focus:placeholder-gray-500 focus:bg-white focus:text-gray-900 focus:outline-none"
            placeholder="Search here"
            onChange={onSearch}
          />
        </div>
      )}
      <Items />
    </div>
  )
}

export default withRouter(SiderMenu)

const fullList = [
  { icon: 'appstore', text: 'Home', to: '/', id: 'general' },
  { icon: 'contacts', text: 'Phone Book', to: '/phonebook', id: 'members' },
  { icon: 'calendar', text: 'Calendar', to: '/calendar', id: 'general' },
  { icon: 'ordered-list', text: 'My Tasks', to: '/operations/task-system', id: 'general' },
  {
    divider: true,
    icon: 'area-chart',
    text: 'Sales',
    to: '/clients',
    id: 'enquiries',
    sub: [
      { icon: 'user', text: 'Clients', to: '/list', id: 'clients' },
      { icon: 'idcard', text: 'Clients Registration', to: '/registration', id: 'clients' },
      { icon: 'message', text: 'Enquiries', to: '/enquiries', id: 'enquiries' },
      { icon: 'money-collect', text: 'Quotes', to: '/quotes', id: 'quotes' },
      { icon: 'schedule', text: 'Sales Orders', to: '/orders', id: 'sales' },
      { icon: 'file-protect', text: 'Invoices', to: '/invoices', id: 'invoices' },
      { icon: 'dollar', text: 'Payments', to: '/payments', id: 'transactions' },
      { icon: 'home', text: 'Deposits', to: '/deposits', id: 'sales' },
      { icon: 'credit-card', text: 'Budgets', to: '/budgets', id: 'salesBudgets' },
    ],
  },
  {
    icon: 'build',
    text: 'Operations',
    to: '/operations/engineering',
    id: 'dwg',
    divider: true,
    sub: [
      { icon: 'highlight', text: 'QC Documents', to: '/dwg', id: 'dwg' },
      { icon: 'folder-open', text: 'Drawings', to: '/qc', id: 'qc' },
    ],
  },
  {
    icon: 'shopping-cart',
    text: 'Purchasing',
    to: '/purchasing',
    id: 'purchases',
    divider: true,
    sub: [
      { icon: 'dashboard', text: 'Dashboard', to: '/dashboard', id: 'purchases' },
      { icon: 'file-unknown', text: 'RFQs', to: '/rfq', id: 'rfq' },
      { icon: 'solution', text: 'Vendor Quotes', to: '/vendor/quotes', id: 'purchases' },
      { icon: 'reconciliation', text: ' Requisitions', to: '/requisitions', id: 'requisitions' },
      { icon: 'shopping-cart', text: ' Purchase Orders', to: '/Order', id: 'purchases' },
      { icon: 'account-book', text: 'Vouchers', to: '/vouchers', id: 'vouchers' },
      { icon: 'euro', text: 'Remittance', to: '/remittance', id: 'remittances' },
      { icon: 'user', text: 'Vendors', to: '/suppliers/list', id: 'suppliers' },
      { icon: 'idcard', text: '  Vendor Registration', to: '/suppliers/registration', id: 'suppliers' },
    ],
  },
  {
    icon: 'global',
    text: 'Delivery',
    id: 'delivery',
    to: '',
    divider: true,
    sub: [
      { icon: 'export', text: 'Delivery Order', to: '/purchasing/delivery', id: 'delivery' },
      { icon: 'file-text', text: 'Release Notes', to: '/hseq/mrn/', id: 'mrn' },
      { icon: 'dropbox', text: 'Packages', to: '/purchasing/package', id: 'package' },
      { icon: 'code-sandbox', text: 'Freight Bookings', to: '/purchasing/cargo', id: 'cargo' },
      { icon: 'dingding', text: 'Tracking', to: '/tracking', id: 'tracking' },
    ],
  },
  {
    icon: 'credit-card',
    text: 'Finance',
    to: '/finance',
    id: 'banks',
    divider: true,
    sub: [
      { icon: 'dashboard', text: 'Dashboard', to: '/dashboard', id: 'reports' },
      { icon: 'book', text: 'Statements', to: '/statements', id: 'banks' },
      { icon: 'bank', text: 'Finance Partners', to: '/lenders/list', id: 'lenderContracts' },
      { icon: 'file-excel', text: 'Reports', to: '/reports', id: 'reports' },
      { icon: 'file-excel', text: 'BAS', to: '/bas', id: 'bas' },
    ],
  },
  {
    icon: 'home',
    text: 'Corporate',
    to: '/corporates',
    id: 'reports',
    divider: true,
    sub: [
      { text: 'Tenants', to: '/subsidiaries/list', id: 'subsidiaries' },
      { text: 'Government', to: '/governments/list', id: 'general' },
      { text: 'Budgets', to: '/budgets', id: 'budgets' },
      { text: 'Accounts', to: '/accounts', id: 'accounts' },
      { text: 'Centers', to: '/centers', id: 'centers' },
      { text: 'Report', to: '/report', id: 'reports' },
      { text: 'Analytics', to: '/analytics', id: 'reports' },
      { text: 'Cashflow', to: '/cashflow', id: 'reports' },
    ],
  },
  {
    icon: 'team',
    text: 'Our People',
    to: '/people',
    id: 'employees',
    divider: true,
    sub: [
      { text: 'Dashboard', to: '/dashboard/', id: 'employees' },
      { text: 'Timesheets', to: '/timesheets', id: 'employees' },
      { text: 'Payrolls', to: '/payrolls', id: 'payrolls' },
      { text: 'Salaries', to: '/salaries', id: 'salaries' },
      { text: 'PayrollClaims', to: '/payrollClaims', id: 'claims' },
      { text: 'Loans', to: '/employeeLoan', id: 'employees' },
      { text: 'Departments', to: '/groups', id: 'groups' },
      { text: 'Devices', to: '/devices', id: 'devices' },
    ],
  },
  {
    icon: 'book',
    text: 'Library',
    divider: true,
    to: '',
    id: 'standards',
    sub: [{ icon: 'file-text', text: 'Standards', to: '/standard', id: 'standards' }],
  },
  {
    icon: 'book',
    text: 'HSEQ',
    divider: true,
    to: '/hseq',
    id: 'controlDocs',
    sub: [
      { icon: 'file-text', text: 'Controlled Documents', to: '/controlledDoc', id: 'controlDocs' },
      { icon: 'file-text', text: 'MRNs', to: '/mrn', id: 'mrn' },
    ],
  },
  {
    icon: 'file-text',
    text: 'Product',
    divider: true,
    to: '',
    id: 'products',
    sub: [
      { icon: 'file-text', text: 'Product Mgt', to: '/product', id: 'products' },
      { icon: 'file-text', text: 'Warranty', to: '/warranty', id: 'products' },
      { icon: 'file-text', text: 'Stock Mgt', to: '/stock', id: 'stock' },
    ],
  },
  {
    icon: 'file-text',
    text: 'Marketing',
    divider: true,
    to: '',
    id: 'general',
    sub: [{ icon: 'file-text', text: 'Newsletter', to: '/newsletter', id: 'newsletter' }],
  },
  {
    icon: 'file-text',
    text: 'Admin',
    divider: true,
    to: '',
    id: 'admin',
    sub: [
      { icon: 'file-text', text: 'Support Tickets', to: '/support', id: 'admin' },
      { icon: 'file-text', text: 'System Emails', to: '/email', id: 'email' },
    ],
  },
  {
    divider: true,
    icon: 'monitor',
    isExternal: true,
    text: 'System Management',
    to: 'https://admin.mmeagroup.com',
    id: 'general',
  },
]
